import {Modal} from 'antd';
import {useEffect, useState} from 'react';

import {Locale} from '../../../provider/locale/localization';
import {useModal} from '../../../provider/modal/modal-hook';
import {CompaniesSelectorFeatureEnum} from '../../../service/feature-companies/feature-companies-const';
import {useCompaniesSelector} from '../../../service/feature-companies/feature-companies-hook';
import {useCreateYandexStory} from '../../../service/yandex-stories/yandex-stories-hook';
import {
    storiesCompanySelectorCompanySchema,
    StoriesCompanySelectorCompanyType,
    YandexStoryFormType,
    YandexStoryTypeEnum,
} from '../../../service/yandex-stories/yandex-stories-type';

import {YandexStoryForm} from './yandex-story-form';
import * as styles from './yandex-story-form.scss';

type PropsType = {
    setIsOpen: (isOpen: boolean) => void;
    companyId?: number;
    type: YandexStoryTypeEnum;
    onCreateSuccess?: VoidFunction;
    brandId?: number;
};

export function CreateYandexStoryFormModal(props: PropsType): JSX.Element {
    const {setIsOpen, companyId, type, onCreateSuccess, brandId} = props;

    const [modalWidth, setModalWidth] = useState<number>(862);

    const companiesSelector = useCompaniesSelector<StoriesCompanySelectorCompanyType>({
        feature: CompaniesSelectorFeatureEnum.YandexStories,
        resourceId: null,
        companySchema: storiesCompanySelectorCompanySchema,
        initialCompaniesCount: 0,
    });

    const {modal} = useModal();

    const {mutateAsync: createStory} = useCreateYandexStory();

    const {initializeSelector} = companiesSelector;

    useEffect(() => {
        initializeSelector();
    }, [initializeSelector]);

    async function handleCreateStory(values: YandexStoryFormType): Promise<void> {
        await createStory(values);
        onCreateSuccess?.();
    }

    return (
        <Modal
            centered
            className={styles.YandexStoryFormModal}
            closable
            destroyOnClose
            footer={null}
            maskClosable
            onCancel={() => {
                modal.confirm({
                    maskClosable: true,
                    title: <Locale stringKey="YANDEX_STORY__CREATE__CONFIRM_CLOSE__TITLE" />,
                    content: <Locale stringKey="YANDEX_STORY__CONFIRM_CLOSE__CONTENT" />,
                    okText: <Locale stringKey="YANDEX_STORY__CREATE__CONFIRM_CLOSE__CONFIRM" />,
                    cancelText: <Locale stringKey="POPUP__BUTTON__CANCEL" />,
                    onOk: async () => {
                        setIsOpen(false);
                    },
                    okButtonProps: {
                        danger: true,
                        rootClassName: styles.YandexStoryFormModal_confirmCLose,
                        type: 'primary',
                    },
                });
            }}
            open
            title={<Locale stringKey="YANDEX_STORY__CREATE__TITLE" />}
            width={modalWidth}
        >
            <YandexStoryForm
                brandId={brandId}
                closeModal={() => {
                    setIsOpen(false);
                }}
                companiesSelector={companiesSelector}
                companyId={companyId}
                mode="create"
                onChangeStep={setModalWidth}
                onSubmit={handleCreateStory}
                type={type}
            />
        </Modal>
    );
}
